import {
  Avatar,
  Box,
  Flex,
  HStack,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";

const FormNavigation: React.FC<{
  stepsColor?: string;
  activeStep?: any;
  logo?: string;
  contentWidth?: Array<any>;
  isLoggedIn?: boolean;
  timer?: any;
  firstName?: string;
  profilePhoto?: string;
  [key: string]: any;
}> = ({
  stepsColor = "orange",
  activeStep,
  logo = "https://res.cloudinary.com/tuteria/image/upload/v1644129853/landing_page_images/Tuteria-Logo-blue.png",
  contentWidth = ["auto", "auto", "auto", "680px", "900px"],
  isLoggedIn,
  timer,
  firstName = "Godwin",
  profilePhoto = "https://res.cloudinary.com/tuteria/image/upload/v1510931421/profile_pics/neizg4691lidnczc36nx.jpg",
  children,
  ...rest
}) => {
  return (
    <Box
      position="sticky"
      top={0}
      bg="white"
      width="100%"
      zIndex="sticky"
      {...rest}
    >
      <Flex
        py={isLoggedIn ? 2 : 4}
        px={[5, 10]}
        align="center"
        justify="space-between"
        borderBottomWidth={["sm", "sm"]}
        borderColor="orange.500"
      >
        <Box width={[96, 106]}>
          <Image src={logo} />
        </Box>

        <Box>
          {isLoggedIn ? (
            <Box p={1} bg="neutral.100" rounded="full">
              <Stack align="center" spacing={3} isInline>
                <Avatar size="sm" src={profilePhoto} />
                <Text pr={3}>{firstName}</Text>
              </Stack>
            </Box>
          ) : (
            <Box />
          )}
        </Box>
        <Box alignSelf="flex-end">{children}</Box>
      </Flex>
    </Box>
  );
};

export default FormNavigation;

export const QuizHeader: React.FC<{
  subject?: string;
  [key: string]: any;
}> = ({ children, subject, ...rest }) => {
  return (
    <Box
      position="sticky"
      borderBottomWidth="2xs"
      borderColor="neutral.500"
      top={0}
      pb={6}
      bg="white"
      width="100%"
      zIndex="sticky"
      {...rest}
    >
      <HStack justify="space-between">
        <Box>{subject}</Box>
        <Box>{children}</Box>
      </HStack>
    </Box>
  );
};
